module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-pop-culture-in-seattle-washington-512b89dc9753796d204f17e0fce04a2c.png";